import keyMirror from 'keymirror'

export default keyMirror({
  CHROME: null,
  FIREFOX: null,
  EDGE: null,
  OPERA: null,
  SAFARI: null,
  IOS_SAFARI: null,
  IOS_CHROME: null,
  IOS_FIREFOX: null,
  ANDROID_CHROME: null,
  ANDROID_FIREFOX: null,
  SAMSUNG: null,
})
